/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryDto as DigiworkMaitreDPosDtoInventoryInventoryDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-dto';
import { UpdateInventoryDto as DigiworkMaitreDPosDtoInventoryUpdateInventoryDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Inventory/update-inventory-dto';

export interface UpdateInventory$Params {
  inventoryId: string;
      body?: DigiworkMaitreDPosDtoInventoryUpdateInventoryDto
}

export function updateInventory(http: HttpClient, rootUrl: string, params: UpdateInventory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryDto>> {
  const rb = new RequestBuilder(rootUrl, updateInventory.PATH, 'put');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoryDto>;
    })
  );
}

updateInventory.PATH = '/api/inventories/{inventoryId}';
